import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'records-security',
  templateUrl: './records-security.component.html',
  styleUrls: ['./records-security.component.scss']
})
export class RecordsSecurityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
